import { useEffect, useRef, useState } from "react";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePostHook from "../../customHooks/usePostHook";
import Spinner from "../Reusable/Spinner";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "../../customHooks/useDebounceHook";
import { downloadApiData, postApiFormData } from "../../helpers/AxiosInstance";
import moment from "moment";
import { toast } from "react-toastify";

const CargoDeliveryChargeTable = (props: any) => {
  const {
    localServiceBranch,
    localServiceType,
    localProductType = [],
    merchantId,
    id,
  } = props;

  const Product_type = localProductType
    ?.map((item: any) => item?.value)
    ?.join(",");
  const [searchParams, setSearchParms] = useSearchParams({
    searchQuery: "",
  });
  const searchQuery = searchParams.get("searchQuery");
  const debounceSearch = useDebounce(searchQuery);

  const {
    data: deliveryChargeData,
    isLoading: DeliveryChargeLoading,
    isRefetching,
  } = useGetHook({
    queryKey: [
      "delivery-charge",
      `delivery-charge-${localServiceBranch}-${localServiceType}-${merchantId}-${Product_type}-${debounceSearch}-${id}`,
    ],
    url: APIS.CARGO_DELIVERY_CHARGE,
    params: {
      branch: localServiceBranch,
      localServiceType: localServiceType,
      product_type: localProductType
        ?.map((item: any) => item?.value)
        ?.join(","),
      merchant: merchantId,
      delivery_charge_template: id,
      search: debounceSearch,
    },
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: [
      "delivery",
      `delivery-${localServiceBranch}-${localServiceType}-${merchantId}-${Product_type}-${debounceSearch}-${id}`,
    ],
    navigateURL: ``,
  });

  const handleDeliveryChargeChange = async (
    destination_city: string,
    product_type: string,
    amount: string,
    weightRange: any
  ) => {
    const url = `${APIS.DELIVERY_CHARGE}`;
    let formData = {
      delivery_charge_template: id,
      pickup_branch: localServiceBranch,
      destination_city: destination_city,
      merchant: merchantId,
      service_type: localServiceType,
      product_type: product_type,
      amount: amount,
      weight_range: weightRange,
    };

    try {
      const res = await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const [rerender, setRerender] = useState(true);

  const handleSearch = (value) => {
    searchParams.set("searchQuery", value);
    setSearchParms(searchParams);
  };

  useEffect(() => {
    setRerender(!rerender);
  }, [deliveryChargeData]);

  const handleDownloadSampleFile = async () => {
    const url = APIS.DELIVERY_CHARGE;
    try {
      await downloadApiData(
        `${url}download-bulk-upload-sample-file/`,
        `Sample-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
      toast.success("Somethings went wrongs");
    }
  };

  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    formData.append("merchant", merchantId);
    formData.append("service_type", localServiceType);

    try {
      const url = `${APIS.DELIVERY_CHARGE}bulkupload/`;
      const res = await postApiFormData({ url, formData, setError: () => {} });
      if (res?.status === 200) {
        toast.success("Uploaded Successfully");
      } else {
        toast.error(res?.data?.message ?? "Something went wrong");
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className={tw`w-full overflow-auto min-h-10`}>
      <div className={tw`flex w-full items-center justify-between mb-2`}>
        <div className={tw`w-52`}>
          <input
            type="text"
            placeholder="Search"
            value={searchQuery ?? ""}
            onChange={(e) => handleSearch(e?.target?.value)}
            className={tw`border w-full border-1 border-primary focus:outline-none p-1`}
          />
        </div>
        <div className={tw`grid grid-cols-2 gap-x-2`}>
          <button
            onClick={handleDownloadSampleFile}
            className={tw`text-primary focus:outline-none`}
          >
            Download Sample
          </button>
          <button
            onClick={handleFileUploadClick}
            className={tw`text-primary focus:outline-none`}
          >
            Upload
          </button>
          <input
            type="file"
            accept=".xlsx, .xls"
            ref={fileInputRef}
            onChange={handleFileChange}
            className={tw`hidden`}
          />
        </div>
      </div>
      {DeliveryChargeLoading || isRefetching ? (
        <Spinner />
      ) : (
        <div className={tw`w-full overflow-x-auto`}>
          <table className={tw`w-full`}>
            <thead className={tw`text-justify`}>
              <tr>
                <th className={tw`pr-4 whitespace-nowrap border`}>
                  Weight &#40;Kg&#41;
                </th>
                {deliveryChargeData?.body?.map((item: any, index: number) => (
                  <th
                    key={`product-type-${item?.group_id}`}
                    className={tw`text-center border relative group`}
                  >
                    {item?.name}
                    <div
                      className={tw`
            absolute left-1/2 top-full mt-1 w-40 -translate-x-1/2
            rounded-md bg-white shadow-lg border p-2 text-sm z-10
            opacity-0 scale-95 pointer-events-none
            group-hover:opacity-100 group-hover:scale-100 group-hover:pointer-events-auto
            transition-all duration-200
          `}
                    >
                      {item?.countries?.length > 0 ? (
                        <ul className={tw`text-left`}>
                          {item?.countries?.map(
                            (country: string, i: number) => (
                              <li key={i}>{country}</li>
                            )
                          )}
                        </ul>
                      ) : (
                        <p className={tw`text-gray-400`}>No countries</p>
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr
                className={tw`even:bg-gray-50 odd:bg-white hover:bg-gray-100 border`}
              >
                <td></td>
                {deliveryChargeData?.body?.map((item: any, index: number) => (
                  <td key={item?.group_id} className={tw`px-2 border`}>
                    <div
                      className={tw`flex items-center justify-around gap-x-2`}
                    >
                      {deliveryChargeData?.header?.map((headerItem, index) => (
                        <span className={tw`whitespace-nowrap`} key={index}>
                          {headerItem?.name}
                        </span>
                      ))}
                    </div>
                  </td>
                ))}
              </tr>
              {deliveryChargeData?.non_flat_weight_ranges?.map(
                ([start, end], index: number) => {
                  return (
                    <tr
                      key={index}
                      className={tw`even:bg-gray-50 odd:bg-white hover:bg-gray-100 border`}
                    >
                      <td className={tw`pr-4 whitespace-nowrap border`}>
                        {`${start} - ${end}`}
                      </td>
                      {deliveryChargeData?.body?.map(
                        (item: any, prodindex: number) => (
                          <td key={item?.group_id} className={tw`px-2 border `}>
                            <div
                              className={tw`flex items-center justify-around gap-x-2`}
                            >
                              {item?.rate?.map((amount, rateIndex) => (
                                <input
                                  key={rateIndex}
                                  type="text"
                                  className={tw`bg-transparent  text-center px-2 py-1`}
                                  onBlur={(event: any) =>
                                    handleDeliveryChargeChange(
                                      item?.group_id,
                                      deliveryChargeData?.header?.[rateIndex]
                                        ?.id,
                                      event?.target?.value,
                                      [start, end]
                                    )
                                  }
                                  defaultValue={amount?.[index]}
                                />
                              ))}
                            </div>
                          </td>
                        )
                      )}
                    </tr>
                  );
                }
              )}
              <tr
                className={tw`even:bg-gray-50 odd:bg-white hover:bg-gray-100 border`}
              >
                <td
                  colSpan={deliveryChargeData?.body?.length + 1}
                  className={tw`font-semibold`}
                >
                  Flat rate per kg
                </td>
              </tr>
              {deliveryChargeData?.flat_weight_ranges?.map(
                ([start, end], index: number) => {
                  const isLast =
                    index === deliveryChargeData.flat_weight_ranges.length - 1;
                  const newIndex =
                    index + deliveryChargeData?.non_flat_weight_ranges.length;
                  return (
                    <tr
                      key={newIndex}
                      className={tw`even:bg-gray-50 odd:bg-white hover:bg-gray-100 border`}
                    >
                      <td className={tw`pr-4 whitespace-nowrap border`}>
                        {isLast ? `${start} and above` : `${start} - ${end}`}
                      </td>
                      {deliveryChargeData?.body?.map(
                        (item: any, prodindex: number) => (
                          <td key={item?.group_id} className={tw`px-2 border `}>
                            <div
                              className={tw`flex items-center justify-around gap-x-2`}
                            >
                              {item?.rate?.map((amount, rateIndex) => (
                                <input
                                  key={rateIndex}
                                  type="text"
                                  className={tw`bg-transparent  text-center px-2 py-1`}
                                  onBlur={(event: any) =>
                                    handleDeliveryChargeChange(
                                      item?.group_id,
                                      deliveryChargeData?.header?.[rateIndex]
                                        ?.id,
                                      event?.target?.value,
                                      [start, end]
                                    )
                                  }
                                  defaultValue={amount?.[newIndex]}
                                />
                              ))}
                            </div>
                          </td>
                        )
                      )}
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CargoDeliveryChargeTable;
